import { usePageLoadingIndicator } from "@/hooks/PageLoadingIndicator/usePageLoadingIndicator"
import classes from "./pageLoadingIndicator.module.css"
import clsx from "clsx"

const PageLoadingIndicator = (props) => {
  const { absolute = false } = props
  const { isPageLoading, loadingState } = usePageLoadingIndicator()

  if (!isPageLoading && !absolute) {
    return null
  }

  return (
    <div
      className={clsx(
        absolute ? classes.root_absolute : classes.root_relative,
        "pointer-events-none"
      )}
    >
      <div className={classes[`indicator_${loadingState}`]} />
    </div>
  )
}

export default PageLoadingIndicator
